import {
  ApiResponse,
  SearchApi,
  SearchProjectRequest,
  SolrProjectReduced,
  SolrResultSolrProjectReduced,
} from '../../api/core';
import { getAuthMiddleware } from '../../Auth/utils/GetAuthMiddleware';
import * as React from 'react';
import { ReactNode, useContext } from 'react';
import { AuthContext } from '../../Auth/components/AuthProvider';
import SearchResults, { ExternalSearchResultProps } from './SearchResults';
import { projectsDefaultSort } from '../../Settings/config';
import { FormattedMessage } from 'react-intl';
import { SearchResultProject } from './components/SearchResultProject';
import { projectFacetsSettings } from '../../Settings/search/project-facets';
import { projectsSortOptions } from '../../Settings/data';
import { useLocation } from 'react-router';

export function SearchResultsProject(props: ExternalSearchResultProps): ReactNode {
  const {actions} = useContext(AuthContext);
  const api: SearchApi = new SearchApi().withMiddleware(getAuthMiddleware(actions));
  const location = useLocation();

  const renderResult = (result: SolrProjectReduced, index: number): ReactNode =>
    <SearchResultProject key={index} position={index+1} result={result} redirectPath={props.externalParams ? location.pathname : undefined}/>;

  return <SearchResults
    searchFunction={async (requestParameters: SearchProjectRequest): Promise<SolrResultSolrProjectReduced | null> => {
      const results: ApiResponse<SolrResultSolrProjectReduced> = await api.searchProjectRaw(requestParameters);
      if (!results.raw.status) {
        return null;
      }
      return await results.value();
    }}
    externalParams={props.externalParams}
    defaultSortOption={projectsDefaultSort}
    facetSettings={projectFacetsSettings}
    title={<FormattedMessage id="search.project.banner.subtitle"/>}
    sortOptions={projectsSortOptions}
    renderResult={renderResult}
    path={'/search/projects'}
    headerImage={require('../../Settings/img/banners/search/project.svg')}
  />;
}

export default SearchResultsProject;
